import React, { Component } from 'react';
import styled from 'react-emotion';

import NotFoundPage from '../NotFoundPage';
import MaxWidth from '../Layout/MaxWidth';

const Header = styled('h1')`
  text-align: center;
  padding: 1rem;
  text-transform: uppercase;
  font-size: 2rem;
  margin-top: 2rem;
  margin-bottom: 2rem;
`;

const Content = styled('div')`
  padding-bottom: 1rem;
  max-width: 800px;
  margin: auto;
  line-height: 1.3;
  font-family: 'Open Sans', sans-serif;
  width: 100%;

  a {
    color: black;
    text-decoration: underline;
  }
`;

class ContentPage extends Component {
  render() {
    const {
      result: { data }
    } = this.props;
    if (data && data.route && data.route.object && data.route.object.content) {
      return (
        <div>
          <MaxWidth>
            <Header>{data.route.object.name}</Header>
            <Content
              dangerouslySetInnerHTML={{ __html: data.route.object.content }}
            />
          </MaxWidth>
        </div>
      );
    } else {
      return <NotFoundPage />;
    }
  }
}

export default ContentPage;
